import { gql } from "apollo-boost"

export const GET_SUBMISSION_DEATILS = gql`
  query Submission($id: ID!) {
    Submission:SubmissionDetails(id: $id) {
      id
      name
      type
      applyingCall
      township
      region
      allies
      alliedOne
      alliedTwo
      BlockingProjectDetails
      BlockingImplementationLocations
      BlockingConsultants
      BlockingDocuments
      BlockingDevelopmentObjective
      implementationPlace
      responsible
      startDate
      endDate
      strategicAxis
      preventionLevel
      scope
      issueDescription
      description
      justification
      developmentObjective
      generalObjective
      state
      status
      statusChangedAt
      deadline
      startDate
      endDate
      signedContractAt
      agreementNumber
      technicalOpinion
      budgeted
      approved
      evidenced
      difference
      createdAt
      implementer {
        id
        councilMembers {
          charge
          name
        }
        rfc
        type
        name
        email
        phone
        vision
        history
        mission
        director
        alliances
        socialObject
        fiscalAddress
        commercialName
        previousSupports
        commercialAddress
        incomesAndExpenses
        legalRepresentative
        institutionalExperience
        proofOfCharitableContributions
        documents {
          id
          url
          name
          type
        }
      }
      specificObjectives {
        orderIndex
        description
      }
      beneficiaries {
        name
        isBlocking
        description
        number
        gender
        educationLevel
        beneficiaryIndex
        age
        preventionLevel
      }
      documents {
        id
        url
        name
        type
      }
      closureDocuments {
        id
        url
        name
        type
      }
    }
  }
`